var _rect, _path, _path2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "226.94px",
    height: "227.535px",
    viewBox: "0 0 226.94 227.535",
    enableBackground: "new 0 0 226.94 227.535",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.795,
    y: 34.824,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -47.5556 113.5071)",
    fill: "#FFFFFF",
    width: 158.883,
    height: 158.668
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3626",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M1.263,113.455l-1.193,1.242l6.109,6.115l1.194-1.263L1.263,113.455z M13.458,125.583l-1.17,1.243l6.11,6.115l1.17-1.242 L13.458,125.583z M25.675,137.717l-1.169,1.263l6.108,6.09l1.17-1.243L25.675,137.717z M37.894,149.87l-1.193,1.24l6.109,6.088 l1.193-1.242L37.894,149.87z M50.088,162.069l-1.169,1.241l6.108,6.04l1.169-1.266L50.088,162.069z M62.307,174.199l-1.17,1.24 l6.086,6.04l1.193-1.239L62.307,174.199z M74.524,186.327l-1.194,1.266l6.11,6.016l1.192-1.241L74.524,186.327z M86.719,198.479 l-1.169,1.242l6.109,6.017l1.169-1.242L86.719,198.479z M98.938,210.609l-1.17,1.241l6.087,6.111l1.194-1.264L98.938,210.609z  M111.159,222.738l-1.194,1.24l2.913,2.842l0.566,0.645l3.864-3.891l-1.234-1.172l-3.266,3.249l0.637,0.548l0.626-0.621 L111.159,222.738z M122.182,216.29l1.245,1.172l6.027-6.09l-1.234-1.192L122.182,216.29z M134.33,204.09l1.242,1.169l6.109-6.039 l-1.265-1.17L134.33,204.09L134.33,204.09z M146.527,191.961l1.263,1.17l6.078-6.111l-1.233-1.171L146.527,191.961z  M158.673,179.738l1.233,1.194l6.109-6.113l-1.233-1.169L158.673,179.738z M170.891,167.537l1.233,1.194l6.108-6.042l-1.264-1.193 L170.891,167.537z M183.076,155.408l1.266,1.169l6.019-6.087l-1.245-1.194L183.076,155.408z M195.224,143.207l1.245,1.171 l6.108-6.113l-1.244-1.17L195.224,143.207z M207.441,131.056l1.244,1.193l6.109-6.111l-1.264-1.173L207.441,131.056L207.441,131.056 z M219.64,118.85l1.265,1.194l5.966-5.965l-1.334-1.313l-1.246,1.243l0.699,0.688l0.617-0.619l-0.617-0.555L219.64,118.85z  M218.183,107.895l1.264-1.244l-6.107-6.085l-1.266,1.244L218.183,107.895z M205.985,95.696l1.244-1.244l-6.038-6.045l-1.234,1.274 L205.985,95.696z M193.84,83.566l1.242-1.243l-6.109-6.115l-1.242,1.243L193.84,83.566z M181.622,71.367l1.265-1.263l-6.11-6.095 l-1.265,1.243L181.622,71.367z M169.434,59.167l1.234-1.264l-6.037-6.024l-1.235,1.243L169.434,59.167z M157.287,47.008l1.233-1.232 l-6.107-6.116l-1.233,1.264L157.287,47.008z M145.07,34.808l1.233-1.242l-6.079-6.106l-1.264,1.264L145.07,34.808z M132.923,22.68 l1.266-1.244l-6.109-6.105l-1.245,1.244L132.923,22.68z M120.727,10.479l1.243-1.263l-6.108-6.083l-1.244,1.231L120.727,10.479z  M109.772,6.801l-1.264-1.264l-6.109,6.116l1.265,1.243L109.772,6.801z M97.553,19.01l-1.242-1.243l-6.108,6.015l1.242,1.263 L97.553,19.01z M85.334,31.139l-1.24-1.243l-6.109,6.034l1.241,1.244L85.334,31.139z M73.141,43.268l-1.264-1.243l-6.11,6.034 l1.265,1.244L73.141,43.268z M60.922,55.417l-1.241-1.263l-6.109,6.104l1.24,1.244L60.922,55.417z M48.705,67.546l-1.241-1.244 l-6.109,6.085l1.241,1.273L48.705,67.546z M36.51,79.675l-1.265-1.244l-6.108,6.116l1.265,1.243L36.51,79.675z M24.292,91.825 l-1.24-1.264l-6.11,6.115l1.242,1.243L24.292,91.825z M12.001,103.953l-1.242-1.242l-6.108,6.095l1.266,1.243L12.001,103.953z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path3628",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M112.877,211.85l0.497,0.478l0.546-0.476l97.273-97.226l0.476-0.547l-98.295-98.273l-0.496,0.576l-97.822,97.224l-0.548,0.475 l0.549,0.546L112.877,211.85z M16.107,113.606l-0.55,0.474l0.55,0.547l97.813-97.223l-0.546-0.546l-0.496,0.546l97.265,97.223 l0.476-0.547l-0.477-0.475l-97.265,97.218l0.498,0.478l0.546-0.477L16.107,113.606z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path3620",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M25.341,89.681l0,23.773l-23.6-0.071L25.341,89.681z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3622",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M41.092,114.152V73.995L57.39,57.418v56.734H41.092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3624",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M73.068,114.152l0-71.843l15.75-17.193v89.037H73.068z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3632",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M105.121,113.454l0-104.167l7.565-9.218l8.182,8.601l0.001,104.784H105.121z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3634",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M152.22,113.454l0.001-72.459l-15.676-16.527v88.986H152.22L152.22,113.454z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3636",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M184.897,113.455V73.509l-16.303-16.303v56.248L184.897,113.455z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3638",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M201.262,89.792v23.663l23.798,0.15L201.262,89.792z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path3630",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M104.908,197.429h16.3l-0.001-2.578l-16.3-0.001L104.908,197.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3640",
    fill: "#010101",
    stroke: "#010101",
    strokeWidth: 0.14,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M116.003,178.901l-0.071-0.953l-0.263-0.838l-0.436-0.691l-0.616-0.549l-0.698-0.287l-0.828-0.071l-0.769,0.072l-0.688,0.286 l-0.546,0.478l-0.364,0.691l-0.262,0.836l-0.071,0.979l0.07,0.885l0.263,0.762l0.436,0.622l0.546,0.501l0.688,0.263l0.839,0.071 l0.839-0.071l0.617-0.264l0.547-0.499l0.436-0.55l0.262-0.766L116.003,178.901z M116.073,183.627l-0.698,0.552l-0.829,0.429 l-0.91,0.263l-1.021,0.072l-1.265-0.143l-1.172-0.264l-0.981-0.503l-0.901-0.764l-0.698-0.81l-0.546-1.053l-0.263-1.17 l-0.141-1.265l0.141-1.385l0.333-1.241l0.546-1.1l0.77-0.978l0.97-0.764l1.052-0.55l1.244-0.358l1.386-0.07l1.598,0.143 l1.314,0.429l1.194,0.74l0.949,0.979l0.769,1.313l0.546,1.529l0.354,1.814l0.071,2.076l-0.07,2.221l-0.355,2.006l-0.616,1.671 l-0.769,1.386l-1.021,1.099l-1.275,0.763l-1.445,0.501l-1.649,0.19l-1.457-0.142l-1.335-0.406l-1.102-0.764l-0.829-0.908 l-0.558-1.17l-0.211-1.313h3.671l0.223,0.765l0.474,0.548l0.688,0.334l0.911,0.073l0.839-0.12l0.688-0.358l0.545-0.693l0.436-0.906 l0.263-1.24L116.073,183.627z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.a4715008e488ea7ed48142fa64efd23f.svg";
export { ForwardRef as ReactComponent };